export var escapeString = function(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
};

//# sourceMappingURL=regex.js.map